import React, { useEffect, useState } from "react";
import HeaderBar from "../../../Components/UI/headerbar";
import LanguageIcon from "../../../Components/Common/svg/language";
import SystemSettingsIcon from "../../../Components/Common/svg/systemSettings";
import ArrowTop from "../../../Components/Common/svg/arrowtop";
import { useQuery, useMutation } from "react-query";
import { getSettings, updateSettings } from "../../../MyApi/settings";
import { Skeleton } from "@mui/material";
import SkeletonWrapper from "../../../Components/UI/skeletonWrapper";
import { toast } from "react-toastify";
import PhoneField from "../../../Components/UI/phoneInput";

const Language = () => {
  const [contact_number,setContactNumber]=useState("")
  const [settingsState,setSettingsState]=useState([])
  
  const {data,isLoading} = useQuery("getSettings",getSettings)
  const settings = data?.data.settings || []
  
  const mutation = useMutation({
    mutationKey: ["updateSettings"],
    mutationFn: (settingsData) => updateSettings(settingsData),
    onSuccess: (data) => {
      toast.success(`${data.message || "تم تحديث الإعدادات بنجاح"}`);
    },
    onError: (error) => {
      toast.error(`${error.response?.data?.message || "حدث خطأ أثناء تحديث الإعدادات"}`);
    }
  });

  useEffect(()=>{
     if (settings.length) {
  setContactNumber(settings[0]?.value || "")
    setSettingsState(settings)
     }
  
  },[data])
  
  const handleChange = (key,e) => {
    const {value} = e.target;
    setContactNumber(e.target.value)
    setSettingsState(prev =>
      prev.map(item =>
        item.key === key
          ? { ...item, value }
          : item
      )
    );
  };

  const handleSave = () => {
    mutation.mutate(settingsState);
  };
  return (
    <div >
      <HeaderBar
        title={"اللغة والإعدادات العامة"}
        content={"إدارة الإعدادات العامة للنظام واللغة"}
      />
      <div className="card rounded-3 ">
        <div className="card-body ">
          <div className="mb-3 d-flex align-items-center">
           
              <LanguageIcon />
         
            <h6 className="d-inline ms-2">إعدادات اللغة والمنطقة </h6>
          </div>
          <div className="row add">
            <div className="col-12">
              <label htmlFor="default-lang" className="form-label">
                اللغة الافتراضية للنظام
              </label>
              <select
                name="default-lang"
                id="default-lang"
                className="form-select"
              >
                <option>العربية</option>
              </select>
            </div>

            {/* <div className="col-md-6">
              <label htmlFor="date" className="form-label">
                التاريخ
              </label>
              <input name="date" type="date" className="form-control" />
            </div> */}
           
    <div className="col-12">  
                <label htmlFor="" className="form-label">رقم خدمة خدمة العملاء</label>
            <SkeletonWrapper isLoading={isLoading}>   
                {/* <PhoneField
                    onChange={handlePhoneChange}
                    phone={curiorInfo.phone}
                    phone_code={curiorInfo.phone_code}
                    setErrors={setErrors}
                  />  */}
                  
                  <input type="text" className="form-control" value={contact_number} onChange={(e)=>handleChange("support_contact_number" ,e)} />   </SkeletonWrapper>
            </div>      
         
        
            {/* <div className="col-md-6">
                 <label htmlFor="default-currency" className="form-label">العملة الافتراضية</label>
                 <input  id="default-currency" type="text" className="form-control" />
            </div>

            <div className="col-12">
                <label htmlFor="time-zone" className="form-label">المنطقة الزمنية</label>
             <select name="time-zone" id="time-zone" className="form-select">
                <option value=""></option>
             </select>
            </div> */}
          </div>
          <div className="card-footer">
            <div className="d-flex justify-content-end">
              <button 
                type="button" 
                className="btn btn-primary"
                onClick={handleSave}
                disabled={mutation.isLoading}
              >
                {mutation.isLoading ? "جاري الحفظ..." : "حفظ الإعدادات"}
              </button>
            </div>
          </div>
        </div>
      </div>
{/* 
      <div className="card rounded-3 ">
        <div className="card-body ">
  <div className="mb-3 d-flex align-items-center">
         
              <SystemSettingsIcon />
          
            <h6 className="d-inline ms-2">شعار النظام</h6>
            </div>
            <div
        className="flex-grow-1 border rounded-4 text-center p-4 upload-box desc"
       
        style={{ cursor: "pointer", minWidth: "250px" }}
      >
        <ArrowTop/>
        <h6 className="fw-bold mb-1 ">تحميل  شعار جديد</h6>
        <p className="text-muted small mb-0 desc">(JPG / PNG) ارفع صورة بجودة عالية</p>

        <input
          type="file"
          name="logo"
          accept="image/png, image/jpeg"
        
          hidden
       
        />
   
          </div>
        </div>

      </div> */}
    </div>
  );
};

export default Language;
